import { ComponentPropsWithoutRef } from 'react';
import classNames from 'classnames';

interface PageProps extends ComponentPropsWithoutRef<'div'>{
  children: React.ReactNode;
}

export default function Page({ className, ...props }: PageProps) {
  return (
    <div className={classNames('w-full h-full rounded-4xl bg-bg overflow-hidden shadow-base-back-3-transparent shadow-down-lg', className)} {...props} />
  );
}
